import {all, takeEvery, put, call } from 'redux-saga/effects';

import actions from "./actions"
import {getPayments, getPaymentStatuses} from "../../services/payment.service";
import { AxiosResponse } from 'axios';

export function* GET_ALL_PAYMENTS(){
    try{
        const response: AxiosResponse<any> = yield call(getPayments);
        if(response.data){
            yield put({
                type: actions.SET_ALL_PAYMENTS,
                payload: response.data
            })
        }
    } catch (e) {
    }
}


export function* GET_PAYMENT_STATUSES(){
    try{
        const response: AxiosResponse<any> = yield call(getPaymentStatuses);
        if(response.data){
            yield put({
                type: actions.SET_PAYMENT_STATUSES,
                payload: response.data
            })
        }
    } catch (e) {
    }
}



export default function* RootSaga(){
    yield all([
        takeEvery(actions.GET_ALL_PAYMENTS, GET_ALL_PAYMENTS),
        takeEvery(actions.GET_PAYMENT_STATUSES, GET_PAYMENT_STATUSES)
    ])
}